import { type ReactElement, type ReactNode } from 'react';

import { Flex } from '@spotify-internal/encore-web';

import { FilterControls, FilterPanel } from './FilterBar';
import { type FilterDefinition } from './provider';

export type FilterRowProps = {
  filters?: FilterDefinition[];
  children?: ReactNode;
  trailing?: ReactNode;
  testId?: string;
};

export const FilterRow = ({
  filters,
  children,
  trailing,
  testId = 'filter-row',
}: FilterRowProps): ReactElement => (
  <Flex direction="column" gap="tighter-2" minWidth="0" data-testid={testId}>
    <Flex alignItems="center" gap="tighter-2" wrap="wrap" minWidth="0">
      {children}
      {trailing}
      <FilterControls filters={filters} hideSearch />
    </Flex>
    <FilterPanel filters={filters} />
  </Flex>
);
